<div class='color-stripe'/>

<style>
  .color-stripe {
    height: 5px;

    background: linear-gradient(90deg,
      var(--purple),
      var(--dark-red),
      var(--red),
      var(--orange),
      var(--yellow),
      var(--light-green),
      var(--green),
      var(--dark-green),
      var(--turquoise),
      var(--dark-blue),
      var(--blue),
      var(--light-blue)
    );
  }

  :global(body.dark) .color-stripe {
    background: linear-gradient(90deg,
      var(--purple-dark),
      var(--dark-red-dark),
      var(--red-dark),
      var(--orange-dark),
      var(--yellow-dark),
      var(--light-green-dark),
      var(--green-dark),
      var(--dark-green-dark),
      var(--turquoise-dark),
      var(--dark-blue-dark),
      var(--blue-dark),
      var(--light-blue-dark)
    );
  }
</style>
